module.exports = __webpack_public_path__ + "static/img/product_banner2.7d3a883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/product_banner2.jpg
// module id = BjL/
// module chunks = 0